import React, { useState } from 'react';
import { SelectProps } from '../../types/SelectProps';
import { Info } from '../icons/Info';

export const Select = ({
  name,
  placeholder,
  value,
  required,
  errorMessage,
  options,
  onChange,
}: SelectProps) => {
  const [isPlaceholderSelected, setIsPlaceholderSelected] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setIsPlaceholderSelected(event.target.value !== placeholder);
    if (onChange) {
      onChange(event);
    }
  };


  return (
    <div className="relative">
      <div className='relative'>
        <select
          className={`p-4 w-full bg-transparent focus:bg-white-smoke ${isPlaceholderSelected ? 'text-bluestone-light' : 'text-[#606F82]'
            } placeholder:text-[#606F82] hover:bg-white-smoke border-0 !border-b !border-b-custom-border active:border-b-bluestone-light !outline-none !ring-0 cursor-pointer`}
          required={required}
          name={name}
          onChange={handleChange}
        >
          <option value={placeholder}>{placeholder}</option>
          {options.map((option) => (
            <option key={option.value} value={option.value} selected={option.value === value}>
              {option.label}
            </option>
          ))}
        </select>

      </div>
      {errorMessage && (
        <div className='flex text-error mt-2'>
          <Info variant='currentColor' className='mr-2' />
          {errorMessage}
        </div>
      )}
    </div>
  );
};
